import React from 'react';

import ExternalJobBoardsLoader from './ExternalJobBoardsLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';
import ExternalJobBoardsTable from './ExternalJobBoardsTable';
import ExternalJobBoardsPageController from './ExternalJobBoardsPageController';
import UpdateExternalJobBoardModal from './UpdateExternalJobBoardModal';
import DeleteExternalJobBoardModal from './DeleteExternalJobBoardModal';
import PreviewLinkDataModal from './PreviewLinkDataModal';
import { useExternalJobBoardsActions } from './ExternalJobBoardsContext';
import { scheduleExternalJobBoardWebpageCaching, scheduleFailedExternalJobBoardWebpageCaching, scheduleExternalJobBoardJobSync, scheduleRefreshPreviewedLinks } from './restApi';
import styles from './ExternalJobBoards.module.scss';

const ExternalJobBoards = () => {
  const { onResponse, onError } = useExternalJobBoardsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleScheduleWebpageCaching = () => {
    scheduleExternalJobBoardWebpageCaching({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  const handleScheduleFailedWebpageCaching = () => {
    scheduleFailedExternalJobBoardWebpageCaching({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  const handleScheduleJobSync = () => {
    scheduleExternalJobBoardJobSync({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  const handleScheduleRefreshPreviewedLinks = () => {
    scheduleRefreshPreviewedLinks({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <>
      <ExternalJobBoardsLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text={'External Job Boards'} />
          <ActionRow>
            <Button onClick={handleScheduleWebpageCaching}>
              Cache All Pending Job Board Webpages
            </Button>
            <Button onClick={handleScheduleFailedWebpageCaching}>
              Retry Failed Job Board Webpages
            </Button>
            <Button onClick={handleScheduleJobSync}>
              Sync All Verified Job Boards
            </Button>
            <Button onClick={handleScheduleRefreshPreviewedLinks}>
              Refresh All Previewed Links
            </Button>
          </ActionRow>
          <ExternalJobBoardsTable />
          <ExternalJobBoardsPageController />
        </Stack>
      </div>
      <UpdateExternalJobBoardModal />
      <DeleteExternalJobBoardModal />
      <PreviewLinkDataModal />
    </>
  );
};

export default ExternalJobBoards;
